<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.medium_group_category_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="addMediumGroupCategory()"
    sbTooltip="{{ 'lang.globals.mediumGroupCategory.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>

<!------------------------------

  side panel / Edit/Create

-------------------------------->

<sb-comp-side-panel (showChange)="showSideBar = $event" [show]="showSideBar" [sidebarHeader]="sidebarHeader"
                    [sidebarTemplate]="compSidePanelTemplate" [width]="600">

</sb-comp-side-panel>

<ng-template #sidebarHeader>
  <div class="d-flex">
    <h4 *ngIf="selectedMediumGroupCategory" [innerHTML]="selectedMediumGroupCategory?.name | truncate : 30"></h4>
    <h4 *ngIf="!selectedMediumGroupCategory">{{ 'lang.globals.newFile' | translate }}</h4>
  </div>
</ng-template>

<ng-template #compSidePanelTemplate>
  <sb-page-mediumGroup-category-edit [mediumGroupCategory]="selectedMediumGroupCategory"
                                     (saveClick)="updateMediumGroupCategory(selectedMediumGroupCategory)"></sb-page-mediumGroup-category-edit>
</ng-template>


<!------------------------------

    Table wrapper

------------------------------->

<sb-table-wrapper-new
  headline="{{'lang.globals.mediumGroupCategories' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="mediumGroupCategories"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'mediumGroupCategories'">


  <!------------------------------

      Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
    >

    </sb-filter-panel>
  </div>


  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.parent' | translate }}
      </th>
      <th>
        {{ 'lang.globals.company' | translate }}
      </th>
      <th class="sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

    Table Body

------------------------------->
  <ng-template #tbody let-mediumCategory>

    <tr>
      <td>
        {{ mediumCategory?.id }}
      </td>
      <td>
        <sb-comp-name-wrapper>
          <span firstLine class="cursor-pointer" (click)="!isInModalContext? editMediumGroupCategory(mediumCategory): ''"
                [innerHtml]="mediumCategory?.name|truncate:30"></span>
        </sb-comp-name-wrapper>
      </td>
      <td>
          <span *ngIf="mediumCategory?.parent" class="cursor-pointer"
                (click)="!isInModalContext? editMediumGroupCategory(mediumCategory.parent) : ''"
                [innerHtml]="mediumCategory?.parent?.name"></span>
      </td>
      <td>
        {{ mediumCategory?.company?.name }}
      </td>
      <td class="tr bw sticky-col last-col">
        @if (!isInModalContext) {
          @if (!mediumCategory.global) {
            <sb-split-button
              [splitButtonItems]="mediumCategory.sbButtons ?? []"
              (selectedAction)="resolveSplitButtonAction(mediumCategory, $event)"
            ></sb-split-button>
          }
        } @else {
          <button sb-button-secondary
                  type="button"
                  ngbTooltip="{{'lang.globals.select' | translate}}"
                  (click)="selectMediumGroupCategory(mediumCategory)"
                  [icon]="'boxChecked'"
                  [color]="'blue'"
                  [iconButton]="true">
          </button>
        }
      </td>
    </tr>
  </ng-template>

  <!------------------------------

   Card Element

------------------------------->

  <!-- no card element -->

</sb-table-wrapper-new>
